import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";
import QuantityUnitCalculationMethodForm from "../components/form/QuantityUnitCalculationMethodForm";
import QuantityUnitCalculationMethodDetails from "../components/details/QuantityUnitCalculationMethodDetails";

export const QuantityUnitSchema: RegistryItem = {
	[CalculationMethodType.QuantityUnit]: {
		Form: QuantityUnitCalculationMethodForm,
		Details: QuantityUnitCalculationMethodDetails,
		fields: {
			"calculationMethod.quantityUnit": {
				path: "quantityUnit",
				rules: { required: true },
			},
			"calculationMethod.price": {
				path: "price",
				rules: { required: true },
			},
			"calculationMethod.customUnit": {
				path: "customUnit",
			},
		},
		toInput: (form) => ({
			quantityUnitCalculationMethodInput: {
				id: form.id,
				quantityUnit: form.quantityUnit,
				price: form.price,
				customUnit: form.customUnit ?? undefined,
			},
		}),
		toForm: (method) => ({
			quantityUnit: method.quantityUnit ?? undefined,
			customUnit: method.customUnit ?? undefined,
		}),
	},
};
